import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.gradient[180]};

  > .center {
    /* height: 100vh; */
    padding: 160px 0 60px 0;
    gap: 32px;
  }

  .link {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: ${({ theme }) => theme.colors.primary.main};

    img {
      width: 28px;
      margin-top: -10px;
    }

    &:hover {
      transition: 0.7s;
      color: ${({ theme }) => theme.colors.primary.light};
    }
  }

  .return {
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${({ theme }) => theme.colors.grey.white};

    svg {
      width: 28px;
      margin-bottom: 5px;
      color: ${({ theme }) => theme.colors.grey.white};

      path {
        stroke-width: 2.5px;
      }
    }
  }
`;

export const GroupContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: ${({ theme }) => theme.colors.grey.black};
  border: 2px solid ${({ theme }) => theme.colors.primary.main};
  padding: 28px 40px;
  border-radius: 36px;
`;

export const GroupImg = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    max-width: 660px;
  }
`;

export const GroupTitle = styled.div`
  h1 {
    font-family: 'Anton', sans-serif;
    text-transform: uppercase;
  }

  h3 {
    font-family: 'Bebas Neue', sans-serif;
  }
`;

export const ButtonGoogle = styled.button`
  width: 100%;
  max-width: 450px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 0;
  padding: 16px 12px;
  gap: 8px;
  background-color: ${({ theme }) => theme.colors.grey.white};

  &:hover {
    transition: 0.7s;
    background-color: ${({ theme }) => theme.colors.grey[200]};
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 48px;
`;

export const GroupFile = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;

  label {
    font-size: 24px;
    font-family: 'Bebas Neue', sans-serif;
    text-transform: uppercase;
  }

  input {
    display: none;
  }

  .upload {
    margin-top: 12px;
    cursor: pointer;
    display: flex;
    border-radius: 8px;
    padding: 8px 20px;
    gap: 4px;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.colors.primary.main};

    svg {
      width: 28px;
      color: ${({ theme }) => theme.colors.grey.white};
    }
  }
`;

export const GroupInput = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2px;

  label {
    font-size: 24px;
    font-family: 'Bebas Neue', sans-serif;
    text-transform: uppercase;
  }

  input,
  select,
  textarea {
    border: 1px solid ${({ theme }) => theme.colors.grey.white};
    background-color: ${({ theme }) => theme.colors.grey[100]};
    padding: 16px 12px;
    border-radius: 8px;
    font-size: 20px;
  }
`;

export const GroupDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const GroupCheck = styled.div`
  display: flex;
  gap: 12px;

  input {
    width: 20px;
    border-radius: 4px;
    cursor: pointer;
  }

  label {
    font-size: 20px;
  }
`;

export const GroupButton = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;

  button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 16px 0px;
    border-radius: 12px;
    font-size: 20px;
    color: ${({ theme }) => theme.colors.grey.white};
    font-weight: 700;
    text-transform: uppercase;
    border: 1px solid ${({ theme }) => theme.colors.primary.main};
    background-color: ${({ theme }) => theme.colors.primary.light};

    svg {
      width: 28px;
      margin-bottom: 5px;
      color: ${({ theme }) => theme.colors.grey.white};

      path {
        stroke-width: 2.5px;
      }
    }

    &:hover {
      transition: 0.7s;
      background-color: ${({ theme }) => theme.colors.primary.main};
    }
  }

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors.grey[100]};
    text-decoration: underline;
    font-weight: 700;
    width: 100%;
    font-size: 20px;
  }
`;

// Verification flow components
export const DropzoneContainer = styled.div`
  width: 100%;
  cursor: pointer;
`;

export const DropzoneContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 48px 24px;
  border: 2px dashed
    ${({ theme, $isDragActive }) =>
      $isDragActive ? theme.colors.primary.light : theme.colors.grey[300]};
  border-radius: 12px;
  background-color: ${({ theme, $isDragActive }) =>
    $isDragActive ? theme.colors.grey[800] : theme.colors.grey[900]};
  transition: all 0.3s ease;
  min-height: 200px;

  svg {
    color: ${({ theme }) => theme.colors.primary.main};
  }

  p {
    font-size: 18px;
    text-align: center;
    color: ${({ theme }) => theme.colors.grey[100]};
  }

  span {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.grey[400]};
  }

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary.main};
    background-color: ${({ theme }) => theme.colors.grey[800]};
  }
`;

export const PreviewImage = styled.img`
  max-width: 100%;
  max-height: 300px;
  border-radius: 8px;
  object-fit: contain;
`;

export const FileInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.grey[800]};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.grey[600]};

  span {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.grey[200]};
  }
`;

export const InfoBox = styled.div`
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.grey[800]};
  border-left: 4px solid ${({ theme }) => theme.colors.primary.main};
  border-radius: 8px;

  p {
    font-size: 16px;
    line-height: 1.6;
    color: ${({ theme }) => theme.colors.grey[100]};
  }
`;

export const SuccessBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 32px;
  background-color: ${({ theme }) => theme.colors.grey[800]};
  border: 2px solid ${({ theme }) => theme.colors.primary.main};
  border-radius: 12px;
  text-align: center;

  h3 {
    font-size: 24px;
    color: ${({ theme }) => theme.colors.primary.main};
    font-family: 'Bebas Neue', sans-serif;
    text-transform: uppercase;
  }

  p {
    font-size: 16px;
    line-height: 1.6;
    color: ${({ theme }) => theme.colors.grey[100]};
  }
`;

export const ProgressIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 32px;
  width: 100%;
  max-width: 400px;
`;

export const ProgressStep = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme, $active }) =>
    $active ? theme.colors.primary.main : theme.colors.grey[700]};
  border: 2px solid
    ${({ theme, $active }) =>
      $active ? theme.colors.primary.light : theme.colors.grey[600]};
  transition: all 0.3s ease;

  span {
    font-size: 16px;
    font-weight: 700;
    color: ${({ theme, $active }) =>
      $active ? theme.colors.grey.white : theme.colors.grey[400]};
  }
`;

export const ProgressLine = styled.div`
  flex: 1;
  height: 2px;
  background-color: ${({ theme, $active }) =>
    $active ? theme.colors.primary.main : theme.colors.grey[700]};
  transition: all 0.3s ease;
`;
